import { a as a$1 } from './chunk-5HWZQ4DE.js';
import * as t from 'react';
import { jsx } from 'react/jsx-runtime';

var a=t.forwardRef(({className:r,...o},s)=>jsx("input",{className:a$1("form-input flex h-10 w-full rounded-md border border-slate-300 bg-transparent px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-700 dark:text-slate-50 dark:focus:ring-slate-400 dark:focus:ring-offset-slate-900",r),ref:s,...o}));a.displayName="Input";

export { a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-NFAQBNQ4.js.map